import { getTheme } from '@fluentui/react';
import {
  Caption1,
  makeStyles,
} from '@fluentui/react-components';
import React, { useContext } from 'react';
import { GridContext } from '@bingads-webui-grid/grid-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Paginator } from '../common/paginator';
import { noDataStyles } from '../common/styles';

const { palette } = getTheme();
const useStyles = makeStyles({
  noData: noDataStyles(palette),
});

export const LandingPageFooter = () => {
  const i18n = useContext(I18nContext);
  const styles = useStyles();
  const { state } = useContext(GridContext);

  return (
    <>
      {state.items.length > 0 ?
        <>
          <Caption1>{`${state.totalCount} ${i18n.getString(_TL_('experiments'))}`}</Caption1>
          <Paginator />
        </> :
        <div className={styles.noData}>
          {i18n.getString(_TL_('There are no lift studies.'))}
        </div>
      }
    </>
  );
};
